import type { ReactNode } from "react";

interface StatCardProps {
  label: ReactNode;
  value: ReactNode;
  sub?: ReactNode;
}

/** Big-number metric (balance, totals). Gradient numerals per design §3. */
export function StatCard({ label, value, sub }: StatCardProps) {
  return (
    <div className="stat">
      <div className="stat__label">{label}</div>
      <div className="stat__value">{value}</div>
      {sub && <div className="stat__sub">{sub}</div>}
    </div>
  );
}
